import React, { useContext } from "react";
import {useQuery} from "@tanstack/react-query";
import {getApiConfig, getAppParams, getGatewayAppParams, getOTA} from "../api";
import FullscreenSpinner from "../components/FullscreenSpinner";
import PropTypes from "prop-types";
import {useParams} from "react-router-dom";


const AppConfigContext = React.createContext({});

function AppConfigContextProvider({children}){

    // Query OTA api
    const OTAQuery = useQuery({
        queryKey:[`OTA`],
        queryFn: (arg) => {
            return getOTA();
        },
        refetchOnWindowFocus: false        
    })

    const configQuery = useQuery({
        queryKey:[`config`],
        queryFn: (arg) => {
            return getApiConfig();
        },
        refetchOnWindowFocus: false
    });

    const appParamQuery = useQuery({
        queryKey:[`appParams`],
        queryFn: (arg) => {
            return getAppParams();
        },
        refetchOnWindowFocus: false
    });

    const appGatewayParamQuery = useQuery({
        queryKey:[`gatewayParams`],
        queryFn: (arg) => {
            return getGatewayAppParams();
        },
        refetchOnWindowFocus: false
    });

    const appParamAvailable = appParamQuery.isSuccess && appParamQuery.data !== null;
    const appGatewayParamAvailable = appGatewayParamQuery.isSuccess && appGatewayParamQuery.data !== null;
    const configDataAvailable = configQuery.isSuccess && configQuery.data !== null;
    const OTAFileAvailable = OTAQuery.isSuccess && OTAQuery.data !== null;

    if (!configDataAvailable)
        return <FullscreenSpinner />;

    const context = {
        config: configQuery.data,
        appParams: appParamAvailable ? appParamQuery.data.params : [],
        gatewayParams: appGatewayParamAvailable ? appGatewayParamQuery.data.params : [],
        OTAFiles: OTAFileAvailable ? OTAQuery.data : []
    };

    return <AppConfigContext.Provider value={context}>
        {children}
    </AppConfigContext.Provider>;
}

AppConfigContextProvider.propTypes = {
    children: PropTypes.element
};

export {AppConfigContextProvider as default, AppConfigContext};